import { Link, matchPath, useLocation } from "react-router-dom";
import {
  BarChart2,
  Brain,
  Home,
  LayoutDashboard,
  Library,
  Sparkles,
  Ticket,
  type LucideIcon,
} from "lucide-react";
import { cn } from "@/lib/utils";

export type NavItem = {
  label: string;
  to: string;
  icon: LucideIcon;
};

export const navItems: NavItem[] = [
  { label: "Home",                    to: "/home",              icon: Home            },
  { label: "Dashboard",               to: "/dashboard",         icon: LayoutDashboard },
  { label: "גרפיקה של התהליך", to: "/process-insights", icon: BarChart2        },
  { label: "Tickets",                 to: "/tickets",           icon: Ticket          },
  { label: "Memory",                  to: "/memory",            icon: Brain           },
  { label: "Skills",                  to: "/skills",            icon: Sparkles        },
  { label: "Knowledge Base",          to: "/knowledge-base",    icon: Library         },
];

export function NavLink({ item }: { item: NavItem }) {
  const location = useLocation();
  const active =
    item.to === "/"
      ? location.pathname === "/"
      : !!matchPath(item.to + "/*", location.pathname);

  return (
    <Link
      to={item.to}
      className={cn(
        "flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors",
        active
          ? "bg-accent text-foreground font-medium"
          : "text-muted-foreground hover:bg-accent hover:text-foreground",
      )}
    >
      <item.icon className="h-[18px] w-[18px]" />
      <span>{item.label}</span>
    </Link>
  );
}
